export const setDashboardSelectedOperationsApprovals = operationsApprovals => ({
  type: 'SET_DASHBOARD_SELECTED_OPERATIONS_APPROVALS',
  payload: operationsApprovals,
});
